import { useEffect,useState, useMemo,useCallback } from 'react';
import axios from 'axios'

//const ax = axios.create(); // export this and use it in all your components

const useAxiosLoader = () => {
    const listEx = ['CTXConnectorHealth', 'ShowBGPSummary', 'login','list_prefix','add_prefix','del_prefix','list_phase_two','fw', "serverlog"] ; //, 'ShowIpv4BGP',
    const [counter, setCounter] = useState(0);
  
    const inc = useCallback(() => setCounter(counter => counter + 1), [
      setCounter
    ]); // add to counter
    const dec = useCallback(() => setCounter(counter => counter - 1), [
      setCounter
    ]); // remove from counter
  
    const interceptors = useMemo(
      () => ({
        request: (config:any) => {
          let flag = true;
          for(const x of listEx){
            if(config.url.includes(x)){
              flag = false
            }
          }
          if(flag){
            inc();
          }
          return config;
        },
        response: (response:any) => {
          let flag = true;
          //console.log("response ", response)
          if(response !== undefined){
            for(const x of listEx){
              if(response.config.url.includes(x)){
                flag = false
              }
            }
            if(flag){
              dec();
            }
          }
          
          return response;
        },
        error: (error:any) => {
          console.log("error in", error)
          dec();
          return Promise.reject(error);
        }
      }),
      /* eslint-disable-next-line*/
      [inc, dec]
    ); // create the interceptors
  
   useEffect(() => {
      // add request interceptors
     
      axios.interceptors.request.use(interceptors.request, interceptors.error);
      
      // add response interceptors
      axios.interceptors.response.use(interceptors.response, interceptors.error);

      /*return () => {
        // remove all intercepts when done
        axios.interceptors.request.eject(interceptors.request);
        axios.interceptors.request.eject(interceptors.error);
        axios.interceptors.response.eject(interceptors.response);
        axios.interceptors.response.eject(interceptors.error);
      };*/
    }, [interceptors]);
  
    return [counter > 0];
  };

export {useAxiosLoader}